var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightIconPurple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66773 0.219761C9.53139 0.360518 9.45479 0.551398 9.45479 0.750426C9.45479 0.949455 9.53139 1.14034 9.66773 1.28109L13.5172 5.25395L0.72728 5.25395C0.534393 5.25395 0.349407 5.33302 0.213015 5.47379C0.0766239 5.61455 7.38691e-08 5.80546 7.14952e-08 6.00453C6.91214e-08 6.2036 0.0766239 6.39451 0.213015 6.53528C0.349407 6.67604 0.534393 6.75512 0.72728 6.75512L13.5172 6.75512L9.66773 10.728C9.53525 10.8695 9.46194 11.0591 9.4636 11.2559C9.46526 11.4527 9.54175 11.641 9.67659 11.7802C9.81143 11.9193 9.99384 11.9983 10.1845 12C10.3752 12.0017 10.5589 11.926 10.6961 11.7893L15.7871 6.5352C15.9234 6.39444 16 6.20356 16 6.00453C16 5.8055 15.9234 5.61462 15.7871 5.47387L10.6961 0.219761C10.5597 0.0790483 10.3748 1.23718e-07 10.1819 1.21418e-07C9.98907 1.19118e-07 9.80412 0.0790483 9.66773 0.219761Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightIconPurple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rightIconPurple.9dcfa3631ecbc48d35493804314a220f.svg";